import {
  PROMO_ALL_BRANDS_ID,
  PROMO_ALL_CLASSES_ID,
  PROMO_DEFAULT_MANUFACTURER,
  PROMO_HISTORICAL_DEFAULT_YEAR,
} from "../../services/promoSimulatorService";
import { PROMO_COLORS } from "../../constants/colors";

// ─── Format helpers ──────────────────────────────────────────────────────────

export const fmt2 = (v) =>
  v == null || Number.isNaN(Number(v)) ? "—" : Number(v).toFixed(2);

export const fmtX = (v) =>
  v == null || Number.isNaN(Number(v)) ? "—" : `${Number(v).toFixed(2)}×`;

export const fmtVol = (v) =>
  v == null || Number.isNaN(Number(v))
    ? "—"
    : `${Number(v).toLocaleString("en-US", { maximumFractionDigits: 0 })} L`;

export const fmtMoney = (v) =>
  v == null || Number.isNaN(Number(v))
    ? "—"
    : Number(v).toLocaleString("en-US", { maximumFractionDigits: 0 });

export const fmtDiscountDepth = (v) =>
  v == null || Number.isNaN(Number(v)) ? "—" : `${Number(v).toFixed(1)}%`;

// ─── Week/filter constants ───────────────────────────────────────────────────

export const WEEK_FILTER_MIN = 1;
export const WEEK_FILTER_MAX = 52;

export const ALL_CALENDAR_WEEKS = Array.from(
  { length: WEEK_FILTER_MAX },
  (_, i) => i + WEEK_FILTER_MIN
);

export const HISTORICAL_YEAR_OPTIONS = [2022, 2023, 2024];

export const PERFORMANCE_SECTION_IDS = [
  "kpi",
  "trends",
  "skuHealth",
  "weakSkus",
  "promoDep",
];

// ─── Filter helpers ──────────────────────────────────────────────────────────

export function createSectionFilters(overrides = {}) {
  return {
    manufacturer: PROMO_DEFAULT_MANUFACTURER,
    brand: PROMO_ALL_BRANDS_ID,
    class: PROMO_ALL_CLASSES_ID,
    startWeek: WEEK_FILTER_MIN,
    endWeek: WEEK_FILTER_MAX,
    year: PROMO_HISTORICAL_DEFAULT_YEAR,
    ...overrides,
  };
}

export function buildPerformanceFilterKey(projectId, f) {
  const weekStart = Math.min(
    Number(f?.startWeek ?? WEEK_FILTER_MIN),
    Number(f?.endWeek ?? WEEK_FILTER_MAX)
  );
  const weekEnd = Math.max(
    Number(f?.startWeek ?? WEEK_FILTER_MIN),
    Number(f?.endWeek ?? WEEK_FILTER_MAX)
  );
  return [
    projectId ?? "",
    f?.manufacturer ?? PROMO_DEFAULT_MANUFACTURER,
    f?.brand ?? PROMO_ALL_BRANDS_ID,
    f?.class ?? "",
    Number(f?.year ?? PROMO_HISTORICAL_DEFAULT_YEAR),
    weekStart,
    weekEnd,
  ].join("|");
}

export function getSectionWeekRange(f) {
  const weekStart = Math.min(
    Number(f?.startWeek ?? WEEK_FILTER_MIN),
    Number(f?.endWeek ?? WEEK_FILTER_MAX)
  );
  const weekEnd = Math.max(
    Number(f?.startWeek ?? WEEK_FILTER_MIN),
    Number(f?.endWeek ?? WEEK_FILTER_MAX)
  );
  return {
    weekStart,
    weekEnd,
    year: Number(f?.year ?? PROMO_HISTORICAL_DEFAULT_YEAR),
  };
}

export function dependencyPctColor(pct) {
  if (pct > 60) return PROMO_COLORS.threat;
  if (pct > 40) return PROMO_COLORS.warning;
  return PROMO_COLORS.safe;
}
